import { render, staticRenderFns } from "./player.vue?vue&type=template&id=e2688148&"
import script from "./player.vue?vue&type=script&lang=ts&"
export * from "./player.vue?vue&type=script&lang=ts&"
import style0 from "./player.vue?vue&type=style&index=0&id=e2688148&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports